export default function() {}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-shape/src/noop.js
// module id = ../../../../d3-shape/src/noop.js
// module chunks = vendor